
import React from "react";
import { Transfer, User } from "@/types";
import { formatCurrency } from "@/lib/utils";

interface TransferHistorySectionProps {
  transfers: Transfer[];
  currentUser: User;
  transfersError: string | null;
}

export function TransferHistorySection({ transfers, currentUser, transfersError }: TransferHistorySectionProps) {
  if (transfersError) {
    return (
      <div>
        <h2 className="text-xl font-bold mb-4">Transfer Requests</h2>
        <div className="rounded-lg border p-4 text-center">
          <p className="text-muted-foreground">Transfer history temporarily unavailable</p>
        </div>
      </div>
    );
  }

  if (transfers.length === 0) return null;

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Transfer Requests</h2>
      <div className="space-y-4">
        {transfers.map((transfer) => (
          <div key={transfer.id} className="rounded-lg border p-4">
            <div className="flex justify-between items-center">
              <div>
                <p className="font-medium">
                  {transfer.fromUserId === currentUser.id ? 'To' : 'From'}: {transfer.description}
                </p>
                <p className="text-sm text-muted-foreground">
                  Amount: {formatCurrency(transfer.amount)}
                </p>
              </div>
              <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                transfer.status === 'pending' ? 'bg-orange-100 text-orange-800' :
                transfer.status === 'approved' ? 'bg-green-100 text-green-800' :
                'bg-red-100 text-red-800'
              }`}>
                {transfer.status.charAt(0).toUpperCase() + transfer.status.slice(1)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
